import { FC, useContext, useEffect, useState } from "react";

import {
  Typography,
  Box,
  Grid,
  useMediaQuery,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Container,
  Select,
  MenuItem,
  FormControl,
  Card,
  Tooltip,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import MyGainsMobileList from "./MyGainsMobileList";
import MyGainsDesktopList from "./MyGainsDesktopList";
import useStyles from "../Styles/GainsStyles";
import AdminHeader from "../SubComponents/AdminHeader";
import Footer from "../SubComponents/Footer";
import ProjectPoolHeading from "../Projects/ProjectPoolHeading";
import Pagination from "../../helpers/Pagination";
import SubscriptionContext from "../../store/Subscription/SubscriptionContext";
import StakeCardSection from "./LockGainsSection";
import LockGainsModal from "./LockGainsModal";
import WaitModal from "../Modals/WaitModal";
import WhaleMaxTier from "./WizardMaxTier";
import BackButton from "../../helpers/BackButton";
import NotStaked from "./NotStaked";
import SuccessModal from "../Modals/SuccessModal";
import TierLevel from "../Profile/TierLevel";
import { Colors } from "../../helpers/theme";
import { FaInfoCircle } from "react-icons/fa";

const Gains: FC = () => {
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("md"));
  const [search, setSearch] = useState("all");
  const { subscriptions, pendingSubscriptions, waitModal, lockedGainsPad, successModal, setSuccessModal } = useContext<any>(SubscriptionContext);
  const [totalPosts, setTotalPosts] = useState(8);
  const [getSubscription, setgetSubscription] = useState<any[]>([]);
  const [filteredResults, setFilteredResults] = useState<any[]>([]);
  const [showLockModal, toggleLockModal] = useState<boolean>(false);
  const [openWaitModal, setOpenWaitMdal] = useState<boolean>(true);
  const [whaleModal, toggleWhaleModal] = useState<boolean>(false);

  useEffect(() => {
    const data = subscriptions.filter(
      (subscription: any) =>
        subscription.status === "locked" || subscription.status === "unlocked"
    );
    setgetSubscription([ ...pendingSubscriptions, ...data]);
  }, [subscriptions, pendingSubscriptions]);

  function handleClickPagination() {
    setTotalPosts((prevValue) => prevValue + 10);
  }

  const searchItems = (value: any) => {
    setSearch(value);
    if (value !== "all") {
      const filterData = getSubscription.filter(
        (subscription: any) => subscription.status === value
      );
      setFilteredResults(filterData);
    } else {
      setFilteredResults(getSubscription);
    }
  };

  const checkStatus = (status: string, expiresAt: Date) => {
    if (status === "locked" && new Date(expiresAt) < new Date()) {
      return "available";
    } else if (status === "locked" && new Date(expiresAt) > new Date()) {
      return "staked";
    } else {
      return status;
    }
  };

  const handleStakeClick = (state: boolean) => {
    if (lockedGainsPad < 100000) {
      toggleLockModal(state)
    } else {
      toggleWhaleModal(state)
    }
  }

  const classes = useStyles();
  const isActiveXS = useMediaQuery(theme.breakpoints.down("xs"));
  return (
    <>
      <AdminHeader />
      <Box
        className={classes.MyGainspages}
        mt={isActive ? 3 : 5}
        mb={5}
        component="section"
      >
        <Container fixed>
          <Grid container>
            <BackButton goBack />
            <Grid item md={12} sm={12} xs={12} lg={12}>
              <Box mb={isActiveXS ? 3 : 5} p={0}>
                <ProjectPoolHeading title1="My" title2="GAINS" />
              </Box>
              <Grid container direction="row" spacing={1}>
                <Grid item lg={4} xs={12}>
                  <StakeCardSection toggleModal={handleStakeClick} />
                </Grid>
                <Grid item lg={4} xs={12}>
                    <Card style={{
                          border: "1px solid " + Colors.secondaryWhite,
                          borderRadius: "17px",
                          boxShadow: "none",
                          marginBottom: "20px",
                          padding: "15px 25px"
                        }}
                        elevation={0}
                    >
                      <TierLevel />
                    </Card>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              <FormControl fullWidth>
                <Box mb={1.5} display="flex" justifyContent="flex-end">
                  <Select
                    id="demo-customized-select"
                    value={search}
                    onChange={(e) => searchItems(e.target.value)}
                    className="select-gains-status-dropdown"
                    margin="dense"
                    variant="outlined"
                    native
                    MenuProps={{
                      disableScrollLock: false,
                    }}
                  >
                    <option value={"all"}>All</option>
                    <option value={"locked"}>Staked / Available</option>
                    <option value={"unlocked"}>Unstaked</option>
                  </Select>
                </Box>
              </FormControl>
            </Grid>

            <Grid item md={12} sm={12} xs={12}>
              {isActive ? (
                <>
                  <Grid container spacing={3}>
                    <>
                      {search === "all" ? (
                        <>
                          {getSubscription?.length < 1 ? (
                            <Grid item md={12} sm={12} xs={12}>
                              <Box textAlign="center" mt={isActive ? 2 : 2}>
                                <NotStaked handleStakeClick={toggleLockModal}/>
                              </Box>
                            </Grid>
                          ) : (
                            <>
                              {getSubscription
                                ?.slice(0, totalPosts)
                                .map((data: any, index: any) => {
                                  const {
                                    id,
                                    duration,
                                    status,
                                    walletAddress,
                                    totalToken,
                                    tickets,
                                    expiresAt,
                                    networkId,
                                    scVersion
                                  } = data;
                                  return (
                                    <MyGainsMobileList
                                      key={index}
                                      id={id}
                                      duration={duration}
                                      expiresAt={expiresAt}
                                      address={walletAddress}
                                      status={checkStatus(status, expiresAt)}
                                      amount={totalToken}
                                      Tickets={tickets}
                                      networkId={networkId}
                                      scVersion={scVersion}
                                    />
                                  );
                                })}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {filteredResults?.length < 1 ? (
                            <Grid item md={12} sm={12} xs={12}>
                              <Box textAlign="center" mt={isActive ? 2 : 2}>
                                <NotStaked handleStakeClick={toggleLockModal}/>
                              </Box>
                            </Grid>
                          ) : (
                            <>
                              {filteredResults
                                ?.slice(0, totalPosts)
                                .map((data: any, index: any) => {
                                  const {
                                    id,
                                    duration,
                                    status,
                                    walletAddress,
                                    totalToken,
                                    tickets,
                                    expiresAt,
                                    networkId,
                                    scVersion
                                  } = data;
                                  return (
                                    <MyGainsMobileList
                                      key={index}
                                      id={id}
                                      duration={duration}
                                      expiresAt={expiresAt}
                                      address={walletAddress}
                                      status={checkStatus(status, expiresAt)}
                                      amount={totalToken}
                                      Tickets={tickets}
                                      networkId={networkId}
                                      scVersion={scVersion}
                                    />
                                  );
                                })}
                            </>
                          )}
                        </>
                      )}
                    </>
                  </Grid>
                </>
              ) : (
                <>
                  <Table className={classes.gainshead}>
                    <TableBody>
                      <TableRow className="Table-header mainBox">
                        {/** Flex Box main */}
                        <TableCell className="" align="left">
                          <Typography
                            component="span"
                            variant="subtitle1"
                            className="fw-bold"
                          >
                            Duration (months)
                          </Typography>
                        </TableCell>
                        <TableCell className="" align="left">
                          <Typography
                            component="span"
                            variant="subtitle1"
                            className="fw-bold"
                          >
                            Status
                          </Typography>
                        </TableCell>
                        <TableCell className="" align="left">
                          <Typography
                            component="span"
                            variant="subtitle1"
                            className="fw-bold"
                          >
                            GAINS{" "}
                          </Typography>
                        </TableCell>
                        <TableCell className="" align="left">
                          <Typography
                            component="span"
                            variant="subtitle1"
                            className="fw-bold"
                          >
                            Address
                          </Typography>
                        </TableCell>
                        <TableCell className="" align="left">
                          <Typography
                            component="span"
                            variant="subtitle1"
                            className="fw-bold"
                            style={{ display: 'inline-flex', alignItems: 'center' }}
                          >
                            # Tickets {" "}
                            <Tooltip
                              title="Think of tickets like raffle tickets. The more GAINS tokens you lock up (stake) and the longer you do it, the more raffle tickets you get. These tickets give you chances to be picked to invest. The more tickets you have, the better your chances of being chosen. Each ticket also decides how much you can invest, so the more tickets picked, the more you can invest."
                            >
                              <span style={{ display: 'inline-flex', alignItems: 'center', marginLeft: 4 }}>
                                <FaInfoCircle />
                              </span>
                            </Tooltip>
                          </Typography>
                        </TableCell>
                        <TableCell className="" align="right">
                          <Typography
                            component="span"
                            variant="subtitle1"
                            className="fw-bold"
                          >
                            Actions
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                  <Table className={classes.firsttable}>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          style={{
                            paddingLeft: "0",
                            paddingRight: "0",
                            paddingBottom: "0",
                          }}
                        >
                          <>
                            {search === "all" ? (
                              <>
                                {getSubscription.length < 1 ? (
                                  <Box textAlign="center">
                                    <NotStaked handleStakeClick={toggleLockModal}/>
                                  </Box>
                                ) : (
                                  <>
                                    {getSubscription
                                      ?.slice(0, totalPosts)
                                      .map((data: any, index: any) => {
                                        const {
                                          id,
                                          duration,
                                          status,
                                          walletAddress,
                                          totalToken,
                                          tickets,
                                          expiresAt,
                                          networkId,
                                          scVersion,
                                        } = data;
                                        return (
                                          <MyGainsDesktopList
                                            key={index}
                                            id={id}
                                            duration={duration}
                                            expiresAt={expiresAt}
                                            address={walletAddress}
                                            status={checkStatus(
                                              status,
                                              expiresAt
                                            )}
                                            amount={totalToken}
                                            Tickets={tickets}
                                            networkId={networkId}
                                            scVersion={scVersion}
                                          />
                                        );
                                      })}
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                {filteredResults?.length < 1 ? (
                                  <Box textAlign="center">
                                    <NotStaked handleStakeClick={toggleLockModal}/>
                                  </Box>
                                ) : (
                                  <>
                                    {filteredResults
                                      ?.slice(0, totalPosts)
                                      .map((data: any, index: any) => {
                                        const {
                                          id,
                                          duration,
                                          status,
                                          walletAddress,
                                          totalToken,
                                          tickets,
                                          expiresAt,
                                          networkId,
                                          scVersion,
                                        } = data;
                                        return (
                                          <MyGainsDesktopList
                                            key={index}
                                            id={id}
                                            duration={duration}
                                            expiresAt={expiresAt}
                                            address={walletAddress}
                                            status={checkStatus(
                                              status,
                                              expiresAt
                                            )}
                                            amount={totalToken}
                                            Tickets={tickets}
                                            networkId={networkId}
                                            scVersion={scVersion}
                                          />
                                        );
                                      })}
                                  </>
                                )}
                              </>
                            )}
                          </>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                  {/* <Box mt={4}>
                    <Grid container justifyContent="center">
                      <Pagination
                        hideNextButton={true}
                        hidePrevButton={true}
                        count={10}
                        variant="outlined"
                        shape="rounded"
                        color="primary"
                      />
                    </Grid>
                  </Box> */}
                </>
              )}
            </Grid>
          </Grid>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            className=""
          >
            {totalPosts < getSubscription?.length && (
              <Pagination handleClick={handleClickPagination} />
            )}
          </Box>

          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            className=""
          >
            {totalPosts < filteredResults?.length && (
              <Pagination handleClick={handleClickPagination} />
            )}
          </Box>
        </Container>
        {
          waitModal && (
            <WaitModal open={openWaitModal} setOpen={setOpenWaitMdal} />
          )
        }
        {
          (showLockModal) && (
            <LockGainsModal open={showLockModal} toggleModal={toggleLockModal} />
          )
        }
        {
          (successModal) && (
            <SuccessModal open={successModal} setOpen={setSuccessModal} tokenName={"Gains"} />
          )
        }
        {
          (whaleModal) && (
            <WhaleMaxTier open={whaleModal} setOpen={toggleWhaleModal} />
          )
        }
      </Box>
      <Footer />
    </>
  );
};

export default Gains;
